import { cssUtil } from "../utils/cssUtil.js";
import { getBaseStyles } from "./commonStyles.js";

export function renderRectangleWidget(context, widget, parent) {

    const el = context.document.createElement("a");
    el.classList.add("widget", "rectangle_widget");
    const breakpoint = context.currentBreakpoint;

    const action = getRectangleAction(widget, context);
    if (action) {
        el.setAttribute("href", action);
        el.style.cursor = "pointer";
        el.style.textDecoration = "none";
    }

    const styles = {
        ...getBaseStyles(widget, breakpoint),
        ...getRectangleStyles(widget)
    };

    el.setAttribute("style", cssUtil.toStyleString(styles));
    el.setAttribute("data-widgetId", widget.uid);
    el.setAttribute("data-widgetType", widget.type);
    el.setAttribute("data-widgetParent", widget.parent);
    parent.appendChild(el);
    return el;
}

function getRectangleStyles(widget) {
    const styles = {};
    const props = widget?.properties?.desktop;
    if (!props) return styles;
  
    const bg = props.background;
    if (bg?.type === "solid") {
        const color = cssUtil.getCssColor(bg);
        if (color) styles["background-color"] = color;
    }

    const border = props.border;
    if (!border) return styles;

    const borderColor = border.color;
    if (borderColor?.type === "solid") {
    styles["border-color"] = cssUtil.getCssColor(borderColor);
}
    if (border.width) styles["border-width"] = cssUtil.px(border.width);
    styles["border-style"] = "solid";

    const r = border.radius || {};
    if (r.topLeft) styles["border-top-left-radius"] = cssUtil.px(r.topLeft);
    if (r.topRight) styles["border-top-right-radius"] = cssUtil.px(r.topRight);
    if (r.bottomRight) styles["border-bottom-right-radius"] = cssUtil.px(r.bottomRight);
    if (r.bottomLeft) styles["border-bottom-left-radius"] = cssUtil.px(r.bottomLeft);

    return styles;
}

function getRectangleAction(widget, context) {
    if (!widget.actions?.length) return null;
    const action = widget.actions[0];

    if (action.type === "link") return action.url;

    return null;
}